import { render } from "./WelcomeName.vue?vue&type=template&id=79d0d737&ts=true"
import script from "./WelcomeName.vue?vue&type=script&lang=ts"
export * from "./WelcomeName.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\r1\\a\\_av-FAI Demo Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__